<template>
    <v-footer
        dark
        padless
    >
        <v-card
        class="flex"
        flat
        tile
        >
            
            <v-card-text class="py-2 white--text text-center">
                <v-btn
                v-for="(social, i) in socials"
                :key="i"
                class="mx-4"
                :href="social.url"
                target="_blank"
                dark
                icon
                >
                    <v-icon :size="social.size"> {{ social.icon }}</v-icon>
                </v-btn>
                <br>
                {{ new Date().getFullYear() }} — <strong>Eko A. C.</strong>
            </v-card-text>
            
        </v-card>
    </v-footer>
</template>
<script>
import { firebase } from '@firebase/app'
import '@firebase/auth'

export default {
    name: 'Footer',
    data () {
        return {
            socials: [
                {icon:'mdi-facebook', url: 'https://www.facebook.com/ekoaguascalientes', size: '24px'},
                {icon:'mdi-instagram', url: 'https://www.instagram.com/ekoags_', size: '24px'},
                {icon:'mdi-youtube', url: 'https://youtube.com/channel/UCjZX4MEDOcuHAN0LrD2YPFg', size: '24px'},
                {icon:'fab fa-tiktok fa-xs', url: 'https://vm.tiktok.com/ZMd4ca6M8/', size: '18px'},
            ],
        }
    },
    computed: {
        authenticated() {
            var user = firebase.auth().currentUser;
            if (user) {
                return true;
            } else {
                return false;
            }
        },
    },
}
</script>